import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { ColorBoxFilter } from '../components/color-box-filter/ColorBoxFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';
import st from '../shared.module.sass';

export const HeadwearCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const [color, state] = useWatch({ name: ['headwear_apparent_colors', 'headwear_states'] });
  const filterCount = [color, state]
    .filter((arr) => Array.isArray(arr) && arr.length > 0).length > 0
    ? 1 : 0;
  useFilterCount('headwear', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="headwearFilter"
      triggerValue={t('events:headwear')}
      {...props}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('events:headwear_colors')}
        name="headwear_apparent_colors"
        options={EVENT_ENUMS.UPPER_BODY.HEADWEAR_COLORS.raw}
      />

      <Divider small />
      <div className={st.Divider} />
      <Divider small />

      <CheckboxCustomFilter
        control={control}
        isMulti
        label={t('events:headwear')}
        name="headwear_states"
        options={EVENT_ENUMS.UPPER_BODY.HEADWEAR.raw}
      />
    </CustomFilterPopover>
  );
};
